module.exports = ".app-component {\n  height: 100%;\n  min-height: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.less
// module id = ./src/app/app.component.less
// module chunks = main